module.exports = __webpack_public_path__ + "static/media/fqa-bg.865feeb2.png";